import { useEffect, useState } from "react";
import { API_BASE, apiFetch } from "../api";

// The signed-in account, including whether it may open the admin analytics page.
export const useMe = () => {
  const [me, setMe] = useState(null);
  useEffect(() => {
    let alive = true;
    apiFetch(`${API_BASE}/me`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => alive && setMe(data))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return me;
};
